import { useCallback } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { getMarketplaceSearchClient } from 'marketplace-ui-common/clients/marketplaceSearchClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from 'marketplace-ui-common/constants/search';
import AppSearchBarResult from '../components/AppSearchBarResult';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO refactor
export function getAppMarketplaceUrl(appContext) {
  let urlRoot;
  if (appContext === 'app') {
    urlRoot = `${getFullUrl('app')}/ecosystem/${PortalIdParser.get()}`;
  } else {
    urlRoot = getFullUrl('ecosystem', {
      hubletOverride: 'na1'
    });
    const lang = getLang();
    switch (lang) {
      case 'de':
      case 'es':
      case 'fr':
      case 'ja':
      case 'pt':
        {
          urlRoot += `/${lang}`;
          break;
        }
      default:
        break;
    }
  }
  return `${urlRoot}/marketplace/apps`;
}
export const VIEW_ALL_APPS = '__VIEW_ALL_APPS__';
export function useAppSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT,
  query = {},
  isUngatedForRecommendationsBadge = false,
  isUngatedForSearchbarUpdates = false
} = {}) {
  const fetcher = useCallback(input => {
    const InAppPublicOnlyContext = appContext === 'public' ? 'public' : 'app';
    const client = getMarketplaceSearchClient(InAppPublicOnlyContext);
    const response = client.post('apps/search', {
      data: {
        language: getLang(),
        queries: [Object.assign({}, query, {
          length: limit,
          search: input
        })]
      }
    });
    return response.then(({
      results: [{
        items,
        total
      }]
    }) => {
      const options = items.map(item => {
        const {
          category,
          categoryV2,
          companyName,
          firstPublishedAt,
          iconUrl,
          installsCount,
          name,
          offeringId,
          recommendation,
          slug,
          tagline
        } = item;
        return {
          dropdownText: /*#__PURE__*/_jsx(AppSearchBarResult, {
            category: category,
            categoryV2: categoryV2,
            companyName: companyName,
            firstPublishedAt: firstPublishedAt,
            iconUrl: iconUrl,
            installsCount: installsCount,
            isUngatedForRecommendationsBadge: isUngatedForRecommendationsBadge,
            isUngatedForSearchbarUpdates: isUngatedForSearchbarUpdates,
            name: name,
            recommended: !!recommendation,
            tagline: tagline
          }),
          href: `${getAppMarketplaceUrl(appContext)}/_detail/${slug}`,
          item,
          linkUse: 'unstyled',
          text: name,
          value: `app::${offeringId}`,
          category: item.category,
          slug
        };
      });
      if (total > limit) {
        options.push({
          href: `${getAppMarketplaceUrl(appContext)}/all-categories?eco_search=${input}`,
          text: I18n.text('marketplace-ui-apps-core.appSearchBarViewAll', {
            total
          }),
          seeAllButton: true,
          value: VIEW_ALL_APPS
        });
      }
      return options;
    }).then(options => grouped ? [{
      text: I18n.text('marketplace-ui-apps-core.appSearchBarGroupLabel'),
      options
    }] : options);
  }, [appContext, grouped, isUngatedForRecommendationsBadge, isUngatedForSearchbarUpdates, limit, query]);
  return {
    fetcher
  };
}